
import { useEffect, useState } from 'react';
import { validaLabelMenuDatas, verifyRules } from 'src/utils/functions';
import useAuth from 'src/hooks/useAuth';
import Iconify from 'src/components/Iconify';
import moment from 'moment';
import v2_actionConfigCrm from 'src/actions/v2/crm/v2_actionConfigCrm';
import actionListaClientesCanais from 'src/actions/clientes/actionListaClientesCanais';
import getActionListaUsuariosByClienteId from 'src/actions/usuarios/getActionListaUsuariosByClienteId';
import v2_actionListaTagsChats from 'src/actions/v2/chats/v2_actionListaTagsChats';
import v2_action_crm_leadsPorUsuarios from 'src/actions/v2/dashboard/relatorios/v2_action_crm_leadsPorUsuarios';
import v2_actionInsightsExecutivo from 'src/actions/v2/dashboard/relatorios/v2_actionInsightsExecutivo';
import v2_actionGerarExcelRelatorioNegocios from 'src/actions/v2/dashboard/relatorios/excel/v2_actionGerarExcelRelatorioNegocios';
import v2_actionInsightsComercial from 'src/actions/v2/dashboard/relatorios/v2_actionInsightsComercial';
import v2_actionInsightsPerformance from 'src/actions/v2/dashboard/relatorios/v2_actionInsightsPerformance';
import MenuDatas2 from 'src/components/MenuDatas2';
import { SelectZui } from 'src/components/zui';
import { RowInput } from 'src/components/forms/RowInput';
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from 'src/@/components/ui/select';
import { Popover, PopoverContent, PopoverTrigger } from 'src/@/components/ui/popover';
import { MultiSelect } from 'src/@/components/ui/multi-select';
import { ZuiTooltip } from 'src/@/components/use/tooltip';
import { Button } from 'src/@/components/ui/button';
import { SkeletonChart } from 'src/@/components/use/skeleton/SkeletonChart';
import { GraficoCrmLeadsPorUsuarios } from '../charts/GraficoCrmLeadsPorUsuarios';
import { GraficoCrmOrigens } from '../charts/GraficoCrmOrigens';
import { GraficoCrmMotivoPerdas } from '../charts/GraficoCrmMotivoPerdas';
import { GraficoGanhosPerdas } from '../charts/GraficoGanhosPerdas';
import { GraficoNegociosGanhosPeriodo } from '../charts/GraficoNegociosGanhosPeriodo';
import { GraficoTotalGanhosPerdas } from '../charts/GraficoTotalGanhosPerdas';
import { GraficoConversaoLeads } from '../charts/GraficoConversaoLeads';
import { GraficoFunilConversao } from '../charts/GraficoFunilConversao';
import { GraficoConversaoEtapas } from '../charts/GraficoConversaoEtapas';
import { GraficoAgingEtapas } from '../charts/GraficoAgingEtapas';
import { GraficoDistribuicaoValor } from '../charts/GraficoDistribuicaoValor';
import { GraficoForecast } from '../charts/GraficoForecast';
import { GraficoConversaoAgentes } from '../charts/GraficoConversaoAgentes';
import WidgetLarge from 'src/components/_dashboard/relatorios/analitico/WidgetLarge';
import { Card, CardContent } from 'src/@/components/ui/card';

export default function TabCrm({ clienteId, periodo, changeClienteId, changePeriodo, campaingConfig, hidePannels }) {
    const { user, cliente } = useAuth();
    const podeVerTodosLeads = verifyRules(user.rules, "supervisionar_leads") || verifyRules(user.rules, "negocios.verTodos");
    const [inicial, setInicial] = useState(new Date());
    const [final, setFinal] = useState(new Date());
    const [metricasTrocaMensagens, setMetricasTrocaMensagens] = useState([]);
    const [metricasOrigens, setMetricaOrigens] = useState([]);
    const [metricasGanhosPerdas, setMetricaGanhosPerdas] = useState([]);
    const [motivosPerdas, setMotivoPerdas] = useState([]);
    const [conversaoEstagios, setConversaoEstagios] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenuDatas = Boolean(anchorEl);
    const inicio2 = moment(inicial).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const [listaClientesCanais, setListaClientesCanais] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pipelineId, setPipelineId] = useState('');
    const [configCrm, setConfigCrm] = useState({});
    const [totais, setTotais] = useState(null);
    const [negociosUsuarios, setNegociosUsuarios] = useState([]);
    const [insightsExec, setInsightsExec] = useState(null);
    const [loadingInsights, setLoadingInsights] = useState(false);
    const [loadingExportExcel, setLoadingExportExcel] = useState(false);
    const [loadingComercial, setLoadingComercial] = useState(false);
    const [comercialData, setComercialData] = useState(null);
    const [loadingFunil, setLoadingFunil] = useState(false);
    const [funilData, setFunilData] = useState(null);
    const [conversaoPorAgente, setConversaoPorAgente] = useState([]);

    // Filtros incorporados do Negócios
    const [qualificacao, setQualificacao] = useState('all');
    const [responsaveis, setResponsaveis] = useState('me');
    const [usuarioSelected, setUsuarioSelected] = useState(null);
    const [chatTags, setChatTags] = useState([]);
    const [listaUsuarios, setListaUsuarios] = useState([]);
    const [listaChatTags, setListaChatTags] = useState([]);

    const filtrosExtras = () => {
        const tagsParam = chatTags && chatTags.length > 0 ? chatTags.join(',') : '';
        const userIdParam = usuarioSelected || user.id;
        return { tagsParam, userIdParam };
    };

    const buscarDataPipiline = async (value, clienteId, pipelineId, dataInicio, dataFinal) => {
        try {
            setLoading(true);
            let startDate = campaingConfig?.start_date ? campaingConfig.start_date : (dataInicio ?? inicio2);
            let endDate = campaingConfig?.end_date ? campaingConfig.end_date : (dataFinal ?? final2);
            const { tagsParam, userIdParam } = filtrosExtras();
            let querys = `?pipeline_id=${pipelineId}&usuario_id=${userIdParam}&cliente_id=${clienteId}&inicio=${startDate}&final=${endDate}`;
            querys += `&periodo=${campaingConfig?.periodo ? 'null' : value}`;
            querys += `&qualificacao=${qualificacao}&responsaveis=${responsaveis}&chat_tags=${tagsParam}`;
            if (campaingConfig) {
                querys += `&campaign_id=${campaingConfig.campaign_id}`
            }
            const res = await v2_action_crm_leadsPorUsuarios(querys);
            setMetricasTrocaMensagens(res.data.data.leads_usuarios);
            setMetricaOrigens(res.data.data.origens);
            setMetricaGanhosPerdas(res.data.data.ganhosPerdas);
            setMotivoPerdas(res.data.data.motivosPerdas);
            setConversaoEstagios(res.data.data.conversaoEstagios);
            setTotais(res.data.data.totais);
            setNegociosUsuarios(res.data.data.negociosUsuarios);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    async function buscarInsightsExecutivo(pid) {
        try {
            setLoadingInsights(true);
            const { tagsParam, userIdParam } = filtrosExtras();
            const querys = `?cliente_id=${cliente._id}&periodo=${periodo}&inicio=${inicio2}&final=${final2}&usuario_id=${userIdParam}&pipeline_id=${pid || pipelineId}&qualificacao=${qualificacao}&responsaveis=${responsaveis}&chat_tags=${tagsParam}`;
            const res = await v2_actionInsightsExecutivo(querys);
            setInsightsExec(res.data.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingInsights(false);
        }
    }

    const fetchComercial = async (pid) => {
        try {
            setLoadingComercial(true);
            const currentPid = pid || pipelineId;
            if (!currentPid) return;
            const { tagsParam, userIdParam } = filtrosExtras();
            const querys = `?cliente_id=${clienteId}&periodo=${periodo}&inicio=${inicio2}&final=${final2}&usuario_id=${userIdParam}&pipeline_id=${currentPid}&qualificacao=${qualificacao}&responsaveis=${responsaveis}&chat_tags=${tagsParam}`;
            const res = await v2_actionInsightsComercial(querys);
            setComercialData(res.data.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingComercial(false);
        }
    }

    const fetchFunil = async (pid) => {
        try {
            setLoadingFunil(true);
            const currentPid = pid || pipelineId;
            const { tagsParam, userIdParam } = filtrosExtras();
            const querys = `?cliente_id=${clienteId}&periodo=${periodo}&inicio=${inicio2}&final=${final2}&usuario_id=${userIdParam}&pipeline_id=${currentPid}&qualificacao=${qualificacao}&responsaveis=${responsaveis}&chat_tags=${tagsParam}`;
            const [resExec, resPerf] = await Promise.all([
                v2_actionInsightsExecutivo(querys),
                v2_actionInsightsPerformance(querys),
            ]);
            setFunilData(resExec.data.data);
            setConversaoPorAgente(resPerf.data.data?.conversaoPorAgente || []);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingFunil(false);
        }
    }

    const handleExportToExcel = async () => {
        try {
            setLoadingExportExcel(true);
            const { tagsParam, userIdParam } = filtrosExtras();
            const querys = `?periodo=${periodo}&usuario_id=${userIdParam}&cliente_id=${cliente._id}&data_inicial=${inicio2}&data_final=${final2}&pipeline_id=${pipelineId}&qualificacao=${qualificacao}&responsaveis=${responsaveis}&chat_tags=${tagsParam}`;
            const response = await v2_actionGerarExcelRelatorioNegocios(querys);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `negocios_${new Date().toISOString().split('T')[0]}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.log('Erro ao exportar negócios:', error);
        } finally {
            setLoadingExportExcel(false);
        }
    };

    async function buscarConfigCrm(querys) {
        try {
            const result = await v2_actionConfigCrm(cliente._id, querys);
            if (result.data.data) {
                let data = result.data.data;
                if (data.pipelines.length > 0) {
                    const pid = data.pipelines[0]._id;
                    setPipelineId(pid);
                    buscarDataPipiline(periodo, cliente._id, pid);
                    buscarInsightsExecutivo(pid);
                    fetchComercial(pid);
                    fetchFunil(pid);
                }
                setConfigCrm(result.data.data);
            }
        } catch (error) {
        }
    }

    async function buscarListaClientesCanais() {
        try {
            const response_clientes_canais = await actionListaClientesCanais(cliente._id)
            setListaClientesCanais(response_clientes_canais.data.data);
        } catch (err) {
            console.log(err)
        }
    }

    const buscarUsuarios = async () => {
        try {
            const res = await getActionListaUsuariosByClienteId(cliente._id);
            setListaUsuarios(res.data.usuarios || []);
        } catch (error) {
            console.log(error);
        }
    };

    const buscarChatTags = async () => {
        try {
            const res = await v2_actionListaTagsChats(`?cliente_id=${cliente._id}`);
            setListaChatTags(res.data?.data || []);
        } catch (error) {
            console.log(error);
        }
    };

    const aplicarFiltros = (pid) => {
        const currentPid = pid || pipelineId;
        if (!currentPid) return;
        buscarDataPipiline(periodo, cliente._id, currentPid);
        buscarInsightsExecutivo(currentPid);
        fetchComercial(currentPid);
        fetchFunil(currentPid);
    };

    useEffect(() => {
        buscarConfigCrm();
        if (cliente.multiSession === 1) {
            buscarListaClientesCanais()
        }
    }, [inicial, final, periodo]);

    useEffect(() => {
        buscarUsuarios();
        buscarChatTags();
    }, []);

    useEffect(() => {
        if (pipelineId) aplicarFiltros(pipelineId);
    }, [qualificacao, responsaveis, usuarioSelected, chatTags]);

    const handlePesquisar = async (periodo, dataInicio, dataFinal) => {
        const promises = [
            changePeriodo('null'),
            buscarDataPipiline(periodo, cliente._id, pipelineId, dataInicio, dataFinal),
        ];
        await Promise.all(promises);
    }

    const formatCurrency = (value) => {
        if (!value) return 'R$ 0';
        return `R$ ${Number(value).toLocaleString('pt-BR')}`;
    };

    return (
        <div className="mb-5 animate-in fade-in slide-in-from-bottom-4 duration-500">

            <div className="flex flex-row items-end gap-3 mt-5 flex-wrap">
                {!campaingConfig && (
                    <div className="w-full sm:w-[220px] shrink-0">
                        <RowInput
                            label={
                                <span className="flex items-center gap-1">
                                    período
                                    <ZuiTooltip content="O período é aplicado sobre a data de criação dos negócios.">
                                        <span className="inline-flex cursor-help">
                                            <Iconify icon="eva:info-outline" className="h-3 w-3 text-gray-400 hover:text-[#7C3AED]" />
                                        </span>
                                    </ZuiTooltip>
                                </span>
                            }
                            value={cliente._id}
                            input={<MenuDatas2
                                anchorEl={anchorEl}
                                open={openMenuDatas}
                                onClose={() => setAnchorEl(false)}
                                inicial={inicial}
                                final={final}
                                changeInicial={newValue => setInicial(newValue)}
                                changeFinal={newValue => { setFinal(newValue) }}
                                content={validaLabelMenuDatas(periodo, inicial, final)}
                                onSelect={value => {
                                    changePeriodo(value);
                                    setAnchorEl(null);
                                }}
                                onPesquisar={(start, end, periodoArg) => {
                                    const inicio = start ? moment(start).format("YYYY-MM-DD") : inicio2;
                                    const fim = end ? moment(end).format("YYYY-MM-DD") : final2;
                                    const novoPeriodo = periodoArg !== undefined ? periodoArg : "null";
                                    handlePesquisar(novoPeriodo, inicio, fim);
                                }}
                            />}
                        />
                    </div>
                )}

                <div className="w-full sm:w-[200px] shrink-0">
                    <RowInput
                        label="funil"
                        input={<SelectZui
                            value={pipelineId}
                            list={configCrm?.pipelines}
                            onChange={e => {
                                let value = e;
                                setPipelineId(value);
                                aplicarFiltros(value);
                            }}
                            itemSelect={(item) => (
                                <SelectItem key={item._id} value={item._id}>
                                    {item.nome}
                                </SelectItem>
                            )}
                        />}
                    />
                </div>

                {/* Mais Filtros */}
                <div className="flex items-end shrink-0">
                    <Popover>
                        <PopoverTrigger asChild>
                            <Button variant="outline" className="h-9 px-3 border-dashed border-gray-300 text-xs text-gray-600 hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-violet-50 bg-transparent">
                                <Iconify icon="mdi:filter-plus" className="mr-2 h-4 w-4" />
                                Mais filtros
                                {(qualificacao !== 'all' || usuarioSelected !== null || chatTags.length > 0) && (
                                    <span className="ml-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-violet-100 text-[10px] font-medium text-violet-800">
                                        {(qualificacao !== 'all' ? 1 : 0) + (usuarioSelected !== null ? 1 : 0) + (chatTags.length > 0 ? 1 : 0)}
                                    </span>
                                )}
                            </Button>
                        </PopoverTrigger>
                        <PopoverContent className="w-[560px] p-4" align="start">
                            <div className="grid grid-cols-2 gap-5">
                                {/* Coluna Esquerda — Filtros do Lead */}
                                <div className="space-y-4">
                                    <h4 className="font-medium text-sm text-gray-900 border-b border-gray-200 pb-2 flex items-center gap-2">
                                        <Iconify icon="mdi:account-tie" className="h-4 w-4 text-[#7C3AED]" />
                                        Filtros do Lead
                                    </h4>
                                    <div className="space-y-3">
                                        {podeVerTodosLeads && (
                                            <div>
                                                <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block">Visualização</label>
                                                <Select
                                                    value={responsaveis}
                                                    onValueChange={(value) => {
                                                        setUsuarioSelected(null);
                                                        setResponsaveis(value);
                                                    }}
                                                >
                                                    <SelectTrigger className="h-9 text-xs w-full border-gray-200 bg-slate-50 focus:ring-[#7C3AED]/20">
                                                        <SelectValue placeholder="Visualização" />
                                                    </SelectTrigger>
                                                    <SelectContent>
                                                        <SelectItem value="me">Meus Leads</SelectItem>
                                                        <SelectItem value="all">Todos Leads</SelectItem>
                                                    </SelectContent>
                                                </Select>
                                            </div>
                                        )}

                                        {podeVerTodosLeads && (
                                            <div>
                                                <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block">Por Usuário</label>
                                                <Select
                                                    value={usuarioSelected || "clear"}
                                                    onValueChange={(value) => {
                                                        if (value === 'clear') {
                                                            setUsuarioSelected(null);
                                                            return;
                                                        }
                                                        setUsuarioSelected(value);
                                                    }}
                                                >
                                                    <SelectTrigger className="h-9 text-xs w-full border-gray-200 bg-slate-50 focus:ring-[#7C3AED]/20">
                                                        <SelectValue placeholder="Selecione um usuário" />
                                                    </SelectTrigger>
                                                    <SelectContent>
                                                        <SelectItem value="clear">Limpar filtro</SelectItem>
                                                        {listaUsuarios.map((item) => (
                                                            <SelectItem key={item._id} value={item._id}>{item.nomeFantasia}</SelectItem>
                                                        ))}
                                                    </SelectContent>
                                                </Select>
                                            </div>
                                        )}

                                        <div>
                                            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block">Qualificação</label>
                                            <Select
                                                value={qualificacao}
                                                onValueChange={(value) => setQualificacao(value)}
                                            >
                                                <SelectTrigger className="h-9 text-xs w-full border-gray-200 bg-slate-50 focus:ring-[#7C3AED]/20">
                                                    <SelectValue placeholder="Qualificação" />
                                                </SelectTrigger>
                                                <SelectContent>
                                                    <SelectItem value="all">Todas as Qualificações</SelectItem>
                                                    {configCrm?.qualificacoes?.map((item) => (
                                                        <SelectItem key={item.value} value={item.value}>{item.nome}</SelectItem>
                                                    ))}
                                                </SelectContent>
                                            </Select>
                                        </div>
                                    </div>
                                </div>

                                {/* Coluna Direita — Filtros do Chat (DESTAQUE) */}
                                <div className="space-y-4 border-l border-gray-200 pl-5">
                                    <h4 className="font-medium text-sm text-gray-900 border-b border-gray-200 pb-2 flex items-center gap-2">
                                        <Iconify icon="ic:round-whatsapp" className="h-4 w-4 text-emerald-600" />
                                        Filtros do Chat
                                    </h4>
                                    <div className="space-y-3">
                                        <div>
                                            <label className="text-xs font-semibold text-emerald-700 uppercase tracking-wider mb-1.5 block">Tags do Chat</label>
                                            <div className={`rounded-md ${chatTags.length > 0 ? 'ring-2 ring-violet-300 ring-offset-1' : ''} transition-all`}>
                                                <MultiSelect
                                                    options={listaChatTags.map((tag) => ({ value: tag._id, label: tag.nome }))}
                                                    defaultValue={chatTags}
                                                    onValueChange={(values) => setChatTags(values)}
                                                    placeholder="Selecione tags"
                                                    variant="default"
                                                    maxCount={2}
                                                    className="text-xs border-emerald-200 bg-emerald-50/40 hover:border-emerald-400"
                                                />
                                            </div>
                                            <p className="text-[10px] text-gray-400 mt-1.5">Filtra leads pelo chat vinculado.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </PopoverContent>
                    </Popover>
                </div>

                <button
                    onClick={handleExportToExcel}
                    disabled={loadingExportExcel}
                    className="h-9 self-end flex items-center gap-2 px-4 rounded-lg border border-dashed border-gray-300 hover:border-green-500 hover:text-green-600 hover:bg-green-50 text-gray-600 bg-transparent transition-colors text-sm font-medium whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {loadingExportExcel ? <Iconify icon="mdi:loading" className="animate-spin h-4 w-4" /> : <Iconify icon="file-icons:microsoft-excel" className="h-4 w-4" />}
                    Exportar Excel
                </button>
            </div>

            {/* Widgets - Linha 1: 3 cols + Linha 2: 4 cols */}
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 mt-6">
                <WidgetLarge loading={loadingInsights} title="Negócios Criados" total={insightsExec?.leadsCriados || 0} icon="mdi:account-plus" iconColor="purple" tooltip="Total de leads criados no periodo selecionado" />
                <WidgetLarge
                    loading={loading}
                    title="Negócios em aberto"
                    total={`${totais?.quantidade_abertos ? totais?.quantidade_abertos?.total_abertos.toFixed(0) : 0}`}
                    icon="mdi:account-funnel-outline"
                    iconColor="green"
                    tooltip="Negocios que ainda estao em andamento no funil"
                />
                <WidgetLarge
                    loading={loading}
                    title="Negócios finalizados"
                    total={`${totais?.quantidade_finalizados ? totais?.quantidade_finalizados?.total_finalizados.toFixed(0) : 0}`}
                    icon="mdi:funnel-remove-outline"
                    iconColor="red"
                    tooltip="Total de negocios finalizados (ganhos ou perdidos) no periodo"
                />
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-3">
                <WidgetLarge
                    loading={loading}
                    title="Média duração"
                    total={`${totais?.media_duracao ? totais?.media_duracao?.media_duracao.toFixed(0) : 0}d`}
                    icon="mdi:clock-outline"
                    iconColor="blue"
                    tooltip="Tempo medio em dias entre a criacao e o fechamento dos negocios"
                />
                <WidgetLarge loading={loadingInsights} title="Qualificados" total={insightsExec?.leadsQualificados || 0} icon="mdi:account-check" iconColor="green" tooltip="Leads que avancaram alem da primeira etapa do funil" />
                <WidgetLarge loading={loadingInsights} title="Perdidos" total={insightsExec?.leadsPerdidos || 0} icon="mdi:account-remove" iconColor="red" tooltip="Leads marcados como perdidos no periodo" />
                <WidgetLarge loading={loadingInsights} title="Conversão %" total={`${insightsExec?.taxaConversao || 0}%`} icon="mdi:percent" iconColor="indigo" tooltip="Percentual de leads ganhos sobre o total de leads fechados (ganhos + perdidos)" />
            </div>

            <div className="border-t border-dashed border-gray-200 my-6" />

               {/* Comercial - Widgets */}
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
                <WidgetLarge loading={loadingComercial} title="Pipeline Aberto" total={formatCurrency(comercialData?.pipelineAberto?.valor)} icon="mdi:funnel" iconColor="purple" tooltip="Valor total dos negocios em aberto no funil selecionado" />
                <WidgetLarge loading={loadingComercial} title="Ganhos" total={formatCurrency(comercialData?.ganhos?.valor)} icon="mdi:trophy" iconColor="green" tooltip="Valor total dos negocios ganhos (convertidos) no periodo" />
                <WidgetLarge loading={loadingComercial} title="Perdidos" total={formatCurrency(comercialData?.perdidos?.valor)} icon="mdi:close-circle" iconColor="red" tooltip="Valor total dos negocios perdidos no periodo" />
            </div>
            <div className="grid grid-cols-4 lg:grid-cols-4 gap-3 mt-3">
                <WidgetLarge loading={loadingComercial} title="Win Rate" total={`${comercialData?.winRate || 0}%`} icon="mdi:chart-arc" iconColor="green" tooltip="Taxa de vitoria: negocios ganhos dividido pelo total de fechados (ganhos + perdidos)" />
                <WidgetLarge loading={loadingFunil} title="Receita Potencial" total={`R$ ${(funilData?.receitaPotencial || 0).toLocaleString('pt-BR')}`} icon="mdi:currency-brl" iconColor="green" tooltip="Soma dos valores de todos os leads ainda em aberto no funil" />
                <WidgetLarge loading={loadingComercial} title="Ciclo Médio" total={`${comercialData?.cicloMedio || 0} dias`} icon="mdi:calendar-clock" iconColor="indigo" tooltip="Tempo medio em dias entre a criacao e o fechamento dos negocios ganhos" />
                <WidgetLarge loading={loadingComercial} title="Ticket Médio" total={formatCurrency(comercialData?.ticketMedio)} icon="mdi:cash" iconColor="purple" tooltip="Valor medio dos negocios ganhos no periodo" />
            </div>

            

            {/* Gráficos - Leads por Usuários + Origens */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-6">
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoCrmLeadsPorUsuarios chartData={metricasTrocaMensagens} />
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoCrmOrigens chartData={metricasOrigens} />
                    )}
                </div>
            </div>

            {/* Conversão de Leads (full width) */}
            <div className="mt-4">
                {loading ? <SkeletonChart /> : (
                    <GraficoConversaoLeads chartData={conversaoEstagios} />
                )}
            </div>

            {/* Ganhos/Perdas + Funil Conversão */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoGanhosPerdas chartData={metricasGanhosPerdas} />
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoFunilConversao chartData={conversaoEstagios} />
                    )}
                </div>
            </div>

            {/* Motivo Perdas + Total Ganhos/Perdas */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoCrmMotivoPerdas chartData={motivosPerdas} />
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loading ? <SkeletonChart /> : (
                        <GraficoTotalGanhosPerdas
                            chartData={[
                                { tipo: "perda", total: totais?.totalPerdido || 0, fill: '#ff5f5f' },
                                { tipo: "ganho", total: totais?.totalGanho || 0, fill: '#DACFFB' },
                            ]}
                        />
                    )}
                </div>
            </div>

            {/* Negócios Ganhos por Período (full width) */}
            {!hidePannels?.includes('last_6_months') && (
                <div className="mt-4">
                    {loading ? <SkeletonChart /> : (
                        <GraficoNegociosGanhosPeriodo chartData={negociosUsuarios} />
                    )}
                </div>
            )}

            <div className="border-t border-dashed border-gray-200 my-6" />

         

            {/* Comercial - Gráficos */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loadingComercial ? <SkeletonChart /> : (
                        <GraficoConversaoEtapas chartData={comercialData?.conversaoPorEtapa || []} />
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loadingComercial ? <SkeletonChart /> : (
                        <GraficoAgingEtapas chartData={comercialData?.tempoPorEtapa || []} />
                    )}
                </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loadingComercial ? <SkeletonChart /> : (
                        <GraficoDistribuicaoValor chartData={comercialData?.distribuicaoFaixaValor || []} />
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loadingComercial ? <SkeletonChart /> : (
                        <GraficoForecast provavel={comercialData?.forecastProvavel || 0} conservador={comercialData?.forecastConservador || 0} />
                    )}
                </div>
            </div>

            <div className="border-t border-dashed border-gray-200 my-6" />

            {/* Funil - Widget + Gráficos */}
   
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                <div className="min-h-[300px] max-h-[420px]">
                    {funilData?.gargalo ? (
                        <Card className="h-full">
                            <CardContent className="p-6 flex flex-col justify-center h-full">
                                <p className="text-sm font-medium text-gray-500 mb-2">Gargalo Atual</p>
                                <p className="text-2xl font-bold text-gray-900">{funilData.gargalo.estagio}</p>
                                <div className="flex gap-4 mt-3">
                                    <div>
                                        <p className="text-xs text-gray-500">Negócios</p>
                                        <p className="text-lg font-semibold">{funilData.gargalo.count}</p>
                                    </div>
                                    <div>
                                        <p className="text-xs text-gray-500">Idade média</p>
                                        <p className="text-lg font-semibold">{funilData.gargalo.avgAge}d</p>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    ) : (
                        loadingFunil ? <SkeletonChart /> : (
                            <Card className="h-full">
                                <CardContent className="p-6 flex items-center justify-center h-full">
                                    <p className="text-sm text-gray-500">Nenhum gargalo identificado</p>
                                </CardContent>
                            </Card>
                        )
                    )}
                </div>
                <div className="min-h-[300px] max-h-[420px] [&>*]:h-full">
                    {loadingFunil ? <SkeletonChart /> : (
                        <GraficoConversaoAgentes chartData={conversaoPorAgente} />
                    )}
                </div>
            </div>
        </div>
    );
}
